import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  ICreateLocationCompany,
  IParamsGetLocationCompany,
  IParamsLocation,
  IPayloadDeleteLocation,
  IReponseLocationDetail,
  IResponseGetLocationCompany,
  IResponseGetLocations,
} from '~/utils/interface/location';

const LocationApi = {
  getLocation(params: IParamsLocation) {
    return axiosClient.get<IApiBaseResponse<IResponseGetLocations>>('api/admin/locations/selection', { params });
  },

  getLocationCompany(params: IParamsGetLocationCompany) {
    return axiosClient.get<IApiBaseResponse<IResponseGetLocationCompany>>('api/admin/location/company', { params });
  },

  createLocation(data: ICreateLocationCompany) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/location/company`, data);
  },

  getLocationDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IReponseLocationDetail>>(`api/admin/location/${id}`);
  },

  updateLocation(id: string | undefined, data: ICreateLocationCompany) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/location/${id}`, data);
  },

  deleteLocation(data: IPayloadDeleteLocation) {
    const url = `api/admin/location`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
};

export default LocationApi;
